import { render, staticRenderFns } from "./contractCreatorExtern.vue?vue&type=template&id=2b3c6284&scoped=true"
import script from "./contractCreatorExtern.vue?vue&type=script&lang=js"
export * from "./contractCreatorExtern.vue?vue&type=script&lang=js"
import style0 from "./contractCreatorExtern.vue?vue&type=style&index=0&id=2b3c6284&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b3c6284",
  null
  
)

export default component.exports